import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { ListActionContext } from "./ListActionContext";
import index from "@beeldit/core/services";

// Mapa global de llamadas activas
const activeRequests = new Map<string, Promise<any>>();

function useIndex(modelConfig: any) {
  const { tableFilters, paginationConfig, orderBy, setTableData } =
    useContext(ListActionContext);
  const errorHandler = useErrorHandler();

  return () => {
    const mergedFilters: Record<string, string> = {};

    // 1. Copiar filtros del contexto
    for (const [key, value] of Object.entries(tableFilters || {})) {
      if (value !== undefined && value !== null && value !== "") {
        mergedFilters[key] = Array.isArray(value) ? value.join(",") : String(value);
      }
    }

    // 2. Añadir todos los indexQueryParams excepto defaultFilters
    const indexParams = modelConfig.indexQueryParams || {};
    for (const [key, value] of Object.entries(indexParams)) {
      if (key === "defaultFilters") continue;
      if (value !== undefined && value !== null && value !== "") {
        mergedFilters[key] = Array.isArray(value) ? value.join(",") : String(value);
      }
    }

    // 3. Añadir defaultFilters si no hay ya valor
    const defaultFilters = indexParams.defaultFilters || {};
    for (const [key, defaultValue] of Object.entries(defaultFilters)) {
      const alreadySet = mergedFilters[key] !== undefined;
      if (!alreadySet && defaultValue !== undefined && defaultValue !== null && defaultValue !== "") {
        mergedFilters[key] = Array.isArray(defaultValue)
          ? defaultValue.join(",")
          : String(defaultValue);
      }
    }

    // 4. Añadir paginación (excluyendo total_items)
    for (const [key, value] of Object.entries(paginationConfig || {})) {
      if (key !== "total_items" && value !== undefined && value !== null && value !== "") {
        mergedFilters[key] = String(value);
      }
    }

    // 5. Ordenar claves y construir query string
    const sortedEntries = Object.entries(mergedFilters).sort(([a], [b]) =>
      a.localeCompare(b)
    );

    let filterPath = sortedEntries
      .map(([key, value]) => `&${key}=${encodeURIComponent(value)}`)
      .join("");

    if (orderBy) {
      filterPath += `&orderBy=${encodeURIComponent(String(orderBy))}`;
    }

    const requestKey = `${modelConfig.endpoint}?${filterPath}`;

    if (activeRequests.has(requestKey)) {
      return;
    }

    const request = index(modelConfig.endpoint, filterPath)
      .then((response: any) => {
        setTableData(response.data);
        return response;
      })
      .catch((error: any) => {
        errorHandler(error);
        throw error;
      })
      .finally(() => {
        activeRequests.delete(requestKey);
      });

    activeRequests.set(requestKey, request);
  };
}

export default useIndex;
